
export const AUTHENTICATION = {
  TAG: 'authentication',
  EVENT: 'Authentication',
  ACTION: {
    LOGIN: 'login',
  },
};

export const AUTHENTICATION_PROMPT = {
  TAG: 'authentication_prompt',
  EVENT: 'Authentication Prompt',
  ACTION: 'prompt',
  STATUS: {
    SHOW: 'show_prompt',
    CLICK: 'click_prompt',
  },
};

export const SURVEY = {
  TAG: 'survey',
  EVENT: 'Survey',
  ACTION: {
    START: 'start_survey',
    SUBMIT: 'submit_survey',
    SHARE: 'share_survey',
  },
};

export const REPORT = {
  TAG: 'report',
  EVENT: 'Report',
  ACTION: {
    DOWNLOAD: 'download_report',
    ARCHIVE_CLICK: 'archive_click',
  },
};

export const RESOURCE = {
  TAG: 'resource',
  EVENT: 'Resource',
  ACTION: {
    RESOURCE_CLICK: 'resource_click',
  },
};

export const BREAKPOINT_MOBILE = 1023;
